import { render, staticRenderFns } from "./ManageMulticoins.vue?vue&type=template&id=234a92fe"
import script from "./ManageMulticoins.vue?vue&type=script&lang=js"
export * from "./ManageMulticoins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports